import { Badge } from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

export const VerticalIconButton = ({ icon, label, onClick, badgeContent, ...props }) => {
  const buttonContent = (
    <>
      {icon}
      <span>{label}</span>
    </>
  );

  return (
    <Button
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        minWidth: 64,
        textTransform: 'none',
        color: 'gray',
        ...props.sx
      }}
      {...props}
    >
      <Badge
        badgeContent={badgeContent}
        color="error"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textTransform: 'none'
        }}>
        {buttonContent}
      </Badge>
    </Button>
  );
};

VerticalIconButton.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func
};